const generateSchemaOrgFaq = (faq_data) => {
  if (!Object.entries(faq_data).length) {
    return
  }

  const schema_org_faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [],
  }

  Object.entries(faq_data).map(async ([question, answer]) =>
    schema_org_faq.mainEntity.push({
      "@type": "Question",
      name: question,
      acceptedAnswer: {
        "@type": "Answer",
        text: answer,
      },
    })
  )

  return schema_org_faq
}

module.exports = generateSchemaOrgFaq
